import { Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LoginFormComponent } from './login/login-form';
import { AuthGuard } from './shared/guards/auth-guard';
import { RecoverPasswordComponent } from './login/recover-password';
import { ResetPasswordComponent } from './login/reset-password';
import { UpdatePasswordComponent } from './login/update-password';
import { LoggedInComponent } from './logged-in/logged-in.component';
import { LocationListComponent } from './location-list/location-list.component';
import { SurveyListComponent } from './survey-list/survey-list.component';
import { SettingsComponent } from './settings/settings.component';
import { SurveyComponent } from './survey/survey.component';
import { SavedSurveysComponent } from './saved-surveys/saved-surveys.component';

export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    children: [
      {
        path: '',
        component: LoginFormComponent
      },
      {
        path: 'recover-password',
        component: RecoverPasswordComponent
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      },
      {
        path: 'update-password',
        component: UpdatePasswordComponent
      }
    ]
  },
  {
    path: 'l',
    component: LoggedInComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'location-list',
        component: LocationListComponent
      },
      {
        path: 'survey-list/:location_id',
        component: SurveyListComponent
      },
      {
        path: 'survey/:location_id/:survey_id',
        component: SurveyComponent
      },
      {
        path: 'saved-surveys',
        component: SavedSurveysComponent
      },
      {
        path: 'settings',
        component: SettingsComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/l/location-list'
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts